import { postRequest } from './request';

export const findOrCreateJob = async ({ atsPostId, atsJobId, job }) => {
  const { id, created, revision_id: revisionId } = await postRequest({
    url: '/extension/find-or-create-job',
    body: { ats_post_id: atsPostId, ats_job_id: atsJobId, job },
  });
  return { id, created, revisionId };
};
